import { useEffect } from 'react';

import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';
// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { INSTAGRAM } from '@/lib/socialProfile';

// Types/Libs
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

/**
 * Hook to navigate from MENTIONS to comments tab when:
 * 1. The selected profile is not Instagram
 * 2. Or any group is selected
 */
export const useNavigateFromMentionsWhenNeeded = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeGroup } = useActiveGroup();
    const { messageFilter, navigateToFilter } = useMessageFilter();

    useEffect(() => {
        // Check if we need to navigate from mentions to comments
        const isMentionsTab = messageFilter === MESSAGE_FILTER_META.mention.key;
        const isNonInstagramProfile = activeSocialProfile?.social_network_type !== INSTAGRAM;
        const isGroup = !activeSocialProfile && activeGroup !== null;

        if (isMentionsTab && (isNonInstagramProfile || isGroup)) {
            navigateToFilter(MESSAGE_FILTER_META.comment.key);
        }
    }, [activeSocialProfile, activeGroup, messageFilter, navigateToFilter]);
};
